var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container",class:[_vm.studio],attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('CookiesControl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }